/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileUpdateRequest
 */
export interface ProfileUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    timezone?: string;
}

/**
 * Check if a given object implements the ProfileUpdateRequest interface.
 */
export function instanceOfProfileUpdateRequest(value: object): value is ProfileUpdateRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ProfileUpdateRequestFromJSON(json: any): ProfileUpdateRequest {
    return ProfileUpdateRequestFromJSONTyped(json, false);
}

export function ProfileUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'],
        'language': json['language'] == null ? undefined : json['language'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

  export function ProfileUpdateRequestToJSON(json: any): ProfileUpdateRequest {
      return ProfileUpdateRequestToJSONTyped(json, false);
  }

  export function ProfileUpdateRequestToJSONTyped(value?: ProfileUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'language': value['language'],
        'timezone': value['timezone'],
    };
}

